/**
 * StatisticDetailContainer
 * --
 */
import React from 'react';
import StatisticDetailPresenter from './StatisticDetailPresenter';

const StatisticDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <StatisticDetailPresenter />
    </>
  );
};

export default StatisticDetailContainer;
